class MobileProductGallery extends HTMLElement {
  constructor() {
    super();
    this.galleryList = this.querySelector('.mobile-product-gallery__list');
    this.items = this.querySelectorAll('.mobile-product-gallery__item');
    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.isScrolling = false;
    this.prevButton = this.querySelector('.mobile-product-gallery__nav--prev');
    this.nextButton = this.querySelector('.mobile-product-gallery__nav--next');
    console.log('MobileProductGallery initialized with', this.items.length, 'items');
  }

  connectedCallback() {
    console.log('MobileProductGallery connected');
    this.initialize();
  }

  initialize() {
    if (this.items.length > 0) {
      console.log('Creating indicators for', this.items.length, 'items');
      this.createIndicators();
      this.setupEventListeners();
      this.updateIndicators();
      this.setupVideoAutoplay();
      this.updateNavigationVisibility();
      this.enableImageModal();

      // Ensure all items are visible
      this.items.forEach((item) => {
        item.style.display = 'block';
        item.style.opacity = '1';
        item.style.visibility = 'visible';
      });
    } else {
      console.warn('No items found in mobile product gallery');
    }
  }

  setupVideoAutoplay() {
    // Find all video elements
    const videos = this.querySelectorAll('video');
    videos.forEach((video) => {
      // Set video attributes
      video.muted = true;
      video.playsInline = true;
      video.loop = true;
      video.autoplay = true;

      // Force play
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.log('Video autoplay failed:', error);
        });
      }
    });

    // Also handle external videos (like YouTube)
    const iframes = this.querySelectorAll('iframe');
    iframes.forEach((iframe) => {
      if (iframe.src.includes('youtube.com') || iframe.src.includes('vimeo.com')) {
        // Add autoplay parameter to the URL
        const url = new URL(iframe.src);
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('mute', '1');
        url.searchParams.set('loop', '1');
        iframe.src = url.toString();
      }
    });
  }

  createIndicators() {
    // Remove any existing indicators
    const existingIndicators = this.querySelector('.mobile-product-gallery__indicators');
    if (existingIndicators) {
      existingIndicators.remove();
    }

    const indicatorsContainer = document.createElement('div');
    indicatorsContainer.className = 'mobile-product-gallery__indicators';
    // Add a non-breaking space to prevent being considered empty
    indicatorsContainer.innerHTML = '&nbsp;';

    this.items.forEach((_, index) => {
      const indicator = document.createElement('div');
      indicator.className = 'mobile-product-gallery__indicator';
      // Add a non-breaking space to prevent being considered empty
      indicator.innerHTML = '&nbsp;';
      if (index === 0) indicator.classList.add('active');
      indicator.addEventListener('click', () => {
        if (!this.isScrolling) {
          this.scrollToItem(index);
        }
      });
      indicatorsContainer.appendChild(indicator);
    });

    this.appendChild(indicatorsContainer);
    console.log('Indicators created:', this.querySelectorAll('.mobile-product-gallery__indicator').length);
  }

  setupEventListeners() {
    // Navigation button events
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        if (!this.isScrolling && this.currentIndex > 0) {
          this.scrollToItem(this.currentIndex - 1);
        }
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        if (!this.isScrolling && this.currentIndex < this.items.length - 1) {
          this.scrollToItem(this.currentIndex + 1);
        }
      });
    }

    // Touch events for swipe
this.galleryList.addEventListener(
  'touchstart',
  (e) => {
    if (this.isScrolling) return;
    if (e.touches.length > 1) return; // Ignore multi-touch (e.g., pinch-to-zoom)
    this.touchStartX = e.touches[0].clientX;
  },
  { passive: true }
);


this.galleryList.addEventListener(
  'touchend',
  (e) => {
    if (this.isScrolling) return;
    if (e.changedTouches.length > 1) return; // Ignore multi-touch end events
    this.touchEndX = e.changedTouches[0].clientX;
    this.handleSwipe();
  },
  { passive: true }
);

    // Scroll event for snap points
    this.galleryList.addEventListener(
      'scroll',
      () => {
        if (this.isScrolling) return;

        const scrollLeft = this.galleryList.scrollLeft;
        const itemWidth = this.galleryList.offsetWidth;
        const newIndex = Math.round(scrollLeft / itemWidth);

        if (newIndex !== this.currentIndex) {
          this.currentIndex = newIndex;
          this.updateIndicators();
          this.updateNavigationVisibility();
        }
      },
      { passive: true }
    );

    // Ensure proper initialization after images load
    window.addEventListener('load', () => {
      this.initialize();
    });
  }

  updateNavigationVisibility() {
    // Hide/show navigation buttons based on current index
    if (this.prevButton) {
      this.prevButton.style.opacity = this.currentIndex === 0 ? '0.5' : '1';
      this.prevButton.style.pointerEvents = this.currentIndex === 0 ? 'none' : 'auto';
    }

    if (this.nextButton) {
      this.nextButton.style.opacity = this.currentIndex === this.items.length - 1 ? '0.5' : '1';
      this.nextButton.style.pointerEvents = this.currentIndex === this.items.length - 1 ? 'none' : 'auto';
    }
  }

  handleSwipe() {
    const diff = this.touchStartX - this.touchEndX;
    const threshold = 50;

    if (Math.abs(diff) > threshold) {
      if (diff > 0 && this.currentIndex < this.items.length - 1) {
        this.scrollToItem(this.currentIndex + 1);
      } else if (diff < 0 && this.currentIndex > 0) {
        this.scrollToItem(this.currentIndex - 1);
      }
    } else {
      // If the swipe wasn't strong enough, snap back to the current item
      this.scrollToItem(this.currentIndex);
    }
  }

  enableImageModal() {

 // Check if mobile media query matches
  if (!window.matchMedia('(max-width: 749px)').matches) {
    return; // Exit early if not mobile
  }

  if (!this.modalInitialized) {
    // Create modal container
    this.modal = document.createElement('div');
    this.modal.className = 'mobile-product-gallery__modal';
    this.modal.innerHTML = `
      <div class="mobile-product-gallery__modal-content">
        <span class="mobile-product-gallery__modal-close">&times;</span>
        <img class="mobile-product-gallery__modal-image" src="" alt="Expanded view" />
      </div>
    `;
    document.body.appendChild(this.modal);

    // Close modal on background click or close button
    this.modal.addEventListener('click', (e) => {
      if (
        e.target === this.modal ||
        e.target.classList.contains('mobile-product-gallery__modal-close')
      ) {
        this.modal.classList.remove('visible');
        document.body.style.overflow = ''; // Re-enable scroll
      }
    });

    this.modalImage = this.modal.querySelector('.mobile-product-gallery__modal-image');
    this.modalInitialized = true;
  }

  // Add click listeners to images
  const images = this.querySelectorAll('.mobile-product-gallery__item img');
  images.forEach((img) => {
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', () => {
      this.modalImage.src = img.src;
      this.modal.classList.add('visible');
      document.body.style.overflow = 'hidden'; // Prevent background scroll
    });
  });
}


  scrollToItem(index) {
    if (index < 0 || index >= this.items.length || this.isScrolling) return;

    this.isScrolling = true;
    const itemWidth = this.galleryList.offsetWidth;
    const targetScroll = index * itemWidth;

    this.galleryList.scrollTo({
      left: targetScroll,
      behavior: 'smooth',
    });

    this.currentIndex = index;
    this.updateIndicators();
    this.updateNavigationVisibility();

    // Reset scrolling flag after animation
    setTimeout(() => {
      this.isScrolling = false;
    }, 500);
  }

  updateIndicators() {
    const indicators = this.querySelectorAll('.mobile-product-gallery__indicator');
    indicators.forEach((indicator, index) => {
      if (index === this.currentIndex) {
        indicator.classList.add('active');
      } else {
        indicator.classList.remove('active');
      }
    });
  }
}

customElements.define('mobile-product-gallery', MobileProductGallery);
